import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Layers, RockBottomLayers} from "../view/RockBottomLayers";
import {RockBottom} from "../RockBottom";
import {Translation} from "../../core/utils/Translation";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {Elastic, gsap, TimelineLite, TweenLite} from "gsap";
import {RockBottomGameMode} from "../server/RockBottomGameMode";
import {RockBottomSound} from "../sound/RockBottomSound";
import {RockBottomParsedInitData} from "../server/data/RockBottomParsedInitData";
import {RockBottomParsedGameData} from "../server/data/RockBottomParsedGameData";
import {RockBottomGameAssets} from "../RockBottomGameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {RockBottomSymbol} from "../symbol/RockBottomSymbol";
import {RockBottomSymbolState} from "../symbol/RockBottomSymbolConfig";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {RockBottomGameConfig} from "../RockBottomGameConfig";

export class FreespinOutro extends ContinueScreen {
    private _spinsPlayedTxt: PIXI.BitmapText;
    private _youWinTxt: BitmapCountUp;
    private _overlay: PIXI.Graphics;
    private _fsOutroSpine: PIXI.spine.Spine;
    private _sfsOutroSpine: PIXI.spine.Spine;
    private _youWin: PIXI.Text;
    private _played: PIXI.Text;
    private _polaroidContainer: PIXI.Container;
    private _string: PIXI.Sprite;
    private _polaroids: PIXI.Sprite[] = [];
    private _polaroidMultipliers: PIXI.BitmapText[] = [];
    private _multPrefix: string = "x";
    private _beatDuration: number = 0;
    private _beatSound: string = "";
    private beatsTl: gsap.core.Timeline;

    constructor() {
        super(RockBottomLayers.getLayer(Layers.SCREENS)!);
        this.init();
        this.onResize();
    }

    public show(onContinueCallBack: () => void) {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData(),
            currMode: RockBottomGameMode = parsedData.mode,
            isFS: boolean = currMode === RockBottomGameMode.FREESPIN,
            isSFS: boolean = currMode === RockBottomGameMode.SUPER_FREESPIN,
            belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowStake(),
            winNumber = SlotGame.apiPlugin.currency.formatValue(parsedData.totalWin),
            spinPlayed = parsedData.numberOfFreespinsPlayed,
            tl: gsap.core.Timeline = gsap.timeline(),
            betValue: number = RockBottom.model.parsedGameData.playedBetValue;

        if (parsedData.totalWin / betValue <= 15) {
            this._beatDuration = 0.33;
            this._beatSound = RockBottomSound.BONUS_OUTRO_HEART_BEAT_LOW;
        } else if (parsedData.totalWin / betValue <= 100) {
            this._beatDuration = 0.2916;
            this._beatSound = RockBottomSound.BONUS_OUTRO_HEART_BEAT_MID;
        } else if (parsedData.totalWin / betValue > 100) {
            this._beatDuration = 0.2375;
            this._beatSound = RockBottomSound.BONUS_OUTRO_HEART_BEAT_HIGH;
        }
        SlotGame.keypadPlugin.hide();

        this.alpha = 0;
        this._overlay.alpha = 0;
        this.visible = true;
        this._overlay.visible = true;

        this.playSpineAnim();
        RockBottomSound.fadeMusic(0, 0.1);
        if (parsedData.totalWin === 0 || belowStakeWinRestriction) {
            this._youWin.visible = false;
        } else {
            tl.to(this, {
                onStart: () => {
                    this._youWin.visible = true;
                    TweenLite.to(this._youWin, {
                        duration: 0.5,
                        alpha: 1,
                        delay: 0.5
                    })
                }
            });
            if (isFS) {
                RockBottomSound.switchMusic({name: RockBottomSound.FREESPIN_ENDING_MUSIC});
            } else if (isSFS) {
                RockBottomSound.switchMusic({name: RockBottomSound.SUPER_FREESPIN_ENDING_MUSIC});
            }
        }
        this._youWinTxt.text = winNumber.toString();
        this._youWinTxt.visible = true;
        this._youWinTxt.scale.set(0.8);
        tl.to(this._youWinTxt, {
            duration: 0.5,
            alpha: 0,
            onComplete: () => {
                this._youWinTxt.alpha = 1;
            }
        }, "+=0.3");

        this._youWinTxt.pivot.set(this._youWinTxt.width / 2, this._youWinTxt.height / 2);
        this._spinsPlayedTxt.text = spinPlayed.toString();
        this._spinsPlayedTxt.pivot.set(this._spinsPlayedTxt.width / 2, this._spinsPlayedTxt.height / 2);

        this._string.visible = isFS;
        this.arrangePolaroids(isFS);

        tl.to([this._string, this._polaroids[0], this._polaroids[1], this._polaroids[2], this._polaroids[3], this._polaroids[4],
            this._polaroidMultipliers[0], this._polaroidMultipliers[1], this._polaroidMultipliers[2], this._polaroidMultipliers[3], this._polaroidMultipliers[4]], {
            alpha: 1,
            duration: 0.5
        }, "+=0.5");

        tl.to([this._played, this._spinsPlayedTxt], {
            duration: 0.5,
            alpha: 0,
            onComplete: () => {
                this._played.alpha = 1;
                this._spinsPlayedTxt.alpha = 1;
            }
        });
        if (RockBottom.isBoostedBetAllowed()) {
            RockBottom.xBetView.toggleXBetFlushAnim(true, true);
            //const xBetBtn: RockBottomXBetButton = RockBottom.xBetView.getXBetButton();
            //xBetBtn.switchOnBonusGame(true);
        }
        tl.add(() => {
            super.show(onContinueCallBack);
        }, "+=0.3");
        if (!belowStakeWinRestriction && parsedData.totalWin !== 0) {
            this.beatsTl = gsap.timeline({repeat: -1});
            this.beatsTl.add(() => {
                RockBottomSound.playTrack(this._beatSound);
            });
            for (let beats: number = 0; beats < 4; beats++) {
                this.beatsTl.to(this._youWinTxt.scale, {
                    duration: this._beatDuration / 2,
                    x: 0.75,
                    y: 0.75,
                    ease: Elastic.easeIn,
                });
                this.beatsTl.to(this._youWinTxt.scale, {
                    duration: this._beatDuration / 2,
                    x: 0.90,
                    y: 0.90,
                    ease: Elastic.easeIn,
                });
                this.beatsTl.to(this._youWinTxt.scale, {
                    duration: this._beatDuration,
                    x: 0.85,
                    y: 0.85,
                    ease: Elastic.easeIn,
                });
                this.beatsTl.to(this._youWinTxt.scale, {
                    duration: this._beatDuration,
                    x: 0.8,
                    y: 0.8,
                    ease: Elastic.easeOut,
                });
            }
            tl.add(this.beatsTl);
        }
    }

    public close(): TimelineLite {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData();
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            TweenLite.to(this, {
                duration: 0.3,
                alpha: 0,
                onComplete: () => {
                    this._spinsPlayedTxt.text = "";
                    this._youWinTxt.text = "";
                    this._youWinTxt.visible = false;
                    this._youWinTxt.alpha = 0;
                    this._youWin.visible = false;
                    this._youWin.alpha = 0;
                    this._spinsPlayedTxt.alpha = 0;
                    this._played.alpha = 0;
                    this._youWinTxt.scale.set(0.8);
                    if (this.beatsTl) {
                        this.beatsTl.clear();
                    }
                }
            });
        });

        RockBottom.background.updateLevelUpTint(false);
        RockBottom.midSymExpand.resetActiveSymbolId();
        this.setReelsOnBonusGameEnd();
        if (parsedData.mode !== RockBottomGameMode.WINCAP_PICK) {
            RockBottomSound.soundPlayer.stopTrack(this._beatSound);
            this._beatSound = "";
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.CONTINUE_BUTTON_BONUS_END});
        }
        //const tl = super.close();
        tl.add(super.close());
        tl.add(() => {
            RockBottom.setBonusMode(false);
            this.resetSpine(this._fsOutroSpine);
            this.resetSpine(this._sfsOutroSpine);
            this.resetOutro();
        });

        RockBottom.background.updateBackGround(RockBottomGameMode.NORMAL);
        RockBottom.freeSpinView.hideView();
        RockBottom.freeSpinView.resetUI();
        if (parsedData.mode !== RockBottomGameMode.WINCAP_PICK) {
            RockBottomSound.switchMusic({name: RockBottomSound.MAIN_GAME_MUSIC});
        }
        return tl;
    }

    public setReelsOnBonusGameEnd(): void {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData();

        RockBottom.initialCountUp.remove();
        RockBottom.reels.forEach((reel, reelId) => {
            const idx: number = (reelId === 0 || reelId === 4) ? 2 : 0,
                idxGap: number = (reelId === 0 || reelId === 4) ? 1 : 0;

            for (let i: number = idx; i < reel.reelView.allSymbols.length; i++) {
                const symToRemove: RockBottomSymbol = reel.reelView.allSymbols[i],
                    oldSymPos: PIXI.Point = symToRemove.position,
                    symName: string = parsedData.reelsEnteringFreespin[reelId][i - idxGap];

                if (symName) {
                    reel.reelView.removeSymbol(symToRemove);
                    const newSymbol: RockBottomSymbol = reel.createSymbol(symName, reelId, RockBottomSymbolState.NORMAL);
                    newSymbol.position.set(oldSymPos.x, oldSymPos.y);
                    reel.reelView.addSymbol(newSymbol);
                    reel.reelView.allSymbols.splice(i, 1, newSymbol);
                }
            }
        });
    }

    private resetOutro(): void {
        this._overlay.visible = false;
        this._string.alpha = 0;
        this._string.visible = false;

        for (let i: number = 0; i < RockBottomGameConfig.MID_SYMS.length; i++) {
            this._polaroids[i].alpha = 0;
            this._polaroidMultipliers[i].alpha = 0;
            this._polaroidMultipliers[i].text = "";
        }
    }

    private arrangePolaroids(isFs: boolean) {
        for (let i: number = 0; i < this._polaroids.length; i++) {
            const polPos: PIXI.Point = this.getPolaroidPos(i, isFs),
                multPos: PIXI.Point = this.getMultPos(i, isFs),
                parsedData: RockBottomParsedGameData = RockBottom.model.parsedGameData,
                symName: string = RockBottomGameConfig.MID_SYMS[i],
                imgType: string = isFs ? "_Clean" : "_Drink",
                activeSymId: number | null = RockBottom.midSymExpand.getActiveSymbolId();

            this._polaroids[i].tint = 0xffffff;
            if (activeSymId) {
                if (i > activeSymId) {
                    this._polaroids[i].texture = RockBottom.assetLoader.getTextures(symName + "_WornOut")[0];
                } else if (i < activeSymId) {
                    this._polaroids[i].texture = RockBottom.assetLoader.getTextures(symName + imgType)[0];
                    this._polaroids[i].tint = 0x555555;
                } else {
                    this._polaroids[i].texture = RockBottom.assetLoader.getTextures(symName + imgType)[0];
                }
            } else {
                if (i !== activeSymId) {
                    this._polaroids[i].texture = RockBottom.assetLoader.getTextures(symName + "_WornOut")[0];
                }
            }

            this._polaroids[i].position.set(polPos.x, polPos.y);
            this._polaroids[i].rotation = this.getPolaroidRotation(i, isFs);

            this._polaroidMultipliers[i].position.set(multPos.x, multPos.y);
            this._polaroidMultipliers[i].rotation = this.getMultRotation(i, isFs);
            this._polaroidMultipliers[i].text = this._multPrefix + parsedData.fsSymbolMultiplier[i];
            this._polaroidMultipliers[i].pivot.set(this._polaroidMultipliers[i].width / 2, this._polaroidMultipliers[i].height / 2);
        }
    }

    private getPolaroidPos(idx: number, isFS: boolean): PIXI.Point {
        let pos: PIXI.Point;
        if (idx === 0) {
            pos = isFS ? new PIXI.Point(100, 360) : new PIXI.Point(120, 385);
        } else if (idx === 1) {
            pos = isFS ? new PIXI.Point(225, 372) : new PIXI.Point(235, 387);
        } else if (idx === 2) {
            pos = isFS ? new PIXI.Point(360, 376) : new PIXI.Point(360, 400);
        } else if (idx === 3) {
            pos = isFS ? new PIXI.Point(490, 374) : new PIXI.Point(505, 380);
        } else {
            pos = isFS ? new PIXI.Point(615, 363) : new PIXI.Point(625, 380);
        }

        return pos;
    }

    private getPolaroidRotation(idx: number, isFS: boolean): number {
        let rotDeg: number = 0;
        if (idx === 0) {
            rotDeg = isFS ? 0.2 : 0;
        } else if (idx === 1) {
            rotDeg = isFS ? 0 : 0;
        } else if (idx === 2) {
            rotDeg = isFS ? 0.05 : 0;
        } else if (idx === 3) {
            rotDeg = isFS ? -0.15 : 0;
        } else {
            rotDeg = isFS ? -0.05 : 0;
        }

        return rotDeg;
    }

    private getMultPos(idx: number, isFS: boolean): PIXI.Point {
        let pos: PIXI.Point;
        if (idx === 0) {
            pos = isFS ? new PIXI.Point(115, 400) : new PIXI.Point(139, 422);
        } else if (idx === 1) {
            pos = isFS ? new PIXI.Point(240, 413) : new PIXI.Point(250, 429);
        } else if (idx === 2) {
            pos = isFS ? new PIXI.Point(376, 417) : new PIXI.Point(380, 440);
        } else if (idx === 3) {
            pos = isFS ? new PIXI.Point(510, 412) : new PIXI.Point(520, 422);
        } else {
            pos = isFS ? new PIXI.Point(638, 398) : new PIXI.Point(647, 417);
        }

        return pos;
    }

    private getMultRotation(idx: number, isFS: boolean): number {
        let rotDeg: number = 0;
        if (idx === 0) {
            rotDeg = isFS ? 0.4 : 0.1;
        } else if (idx === 1) {
            rotDeg = isFS ? 0.3 : 0.4;
        } else if (idx === 2) {
            rotDeg = isFS ? 0.2 : 0.2;
        } else if (idx === 3) {
            rotDeg = isFS ? 0.15 : 0.3;
        } else {
            rotDeg = isFS ? 0.1 : 0.1;
        }

        return rotDeg;
    }

    private createSpinsPlayedText(): void {
        this._spinsPlayedTxt = new PIXI.BitmapText("", {
            fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 18,
            letterSpacing: -15
        });
        this._spinsPlayedTxt.position.set(360, 545);
        this._spinsPlayedTxt.alpha = 0;
        this._container.addChild(this._spinsPlayedTxt);
    }

    private createYouWonText(): void {
        this._youWinTxt = new BitmapCountUp({
            fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 24,
            letterSpacing: -15
        });
        this._youWinTxt.position.set(360, 210);
        this._youWinTxt.shrinkSize = true;
        this._youWinTxt.maxTextWidth = 660;
        this._youWinTxt.visible = false;
        this._youWinTxt.alpha = 0;
        this._container.addChild(this._youWinTxt);
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics;
        this._overlay.alpha = 0;
        this._overlay.beginFill(0x000000, 1);
        this._overlay.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
        this._overlay.endFill();
        this._overlay.visible = false;
        this._container.addChild(this._overlay);
    }

    private onResize(): void {
        if (this._overlay) {
            this._overlay.clear();
            this._overlay.beginFill(0x000000, 1);
            this._overlay.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
            this._overlay.endFill();
        }
    }

    private createPolaroids(): void {
        this._polaroidContainer = new PIXI.Container();
        this._string = this.createFSString("fsOutroString");
        this._polaroidContainer.addChild(this._string);

        for (let i: number = 0; i < RockBottomGameConfig.MID_SYMS.length; i++) {
            const symName: string = RockBottomGameConfig.MID_SYMS[i];

            this._polaroids.push(this.createPolaroidImage(symName + "_Clean"));
            this._polaroidMultipliers.push(this.createMult());
            this._polaroidContainer.addChild(this._polaroids[i], this._polaroidMultipliers[i]);
        }

        this._container.addChild(this._polaroidContainer);
    }

    private createPolaroidImage(spriteName: string): PIXI.Sprite {
        const sprite: PIXI.Sprite = this.createSprite(spriteName);
        sprite.scale.set(0.7);

        return sprite;
    }

    private createFSString(spriteName: string): PIXI.Sprite {
        const sprite: PIXI.Sprite = this.createSprite(spriteName);
        sprite.position.set(360, 310);
        sprite.scale.set(0.95, 1);

        return sprite;
    }

    private createMult(): PIXI.BitmapText {
        const mult: PIXI.BitmapText = new PIXI.BitmapText("", {
            fontName: RockBottomGameAssets.BITMAP_ON_POLAROID,
            fontSize: 16
        });
        mult.position.set(360);
        mult.alpha = 0;
        return mult;
    }

    private createSprite(spriteName: string): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(RockBottom.assetLoader.getTextures(spriteName)[0]);
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(360);
        sprite.alpha = 0;
        return sprite;
    }

    private init(): void {
        this.createOverlay();
        this.createFSOutroSpine();
        this.createSFSOutroSpine();
        this.createYouWonText();
        this.createPolaroids();
        this.createSpinsPlayedText();
        this._youWin = new PIXI.Text(Translation.translation("You won:"), new PIXI.TextStyle({
            fill: 0xffffff,
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 50,
            stroke: 0x000000,
            strokeThickness: 10,
            lineJoin: "round"
        }));
        this._youWin.anchor.set(0.5, 0.5);
        this._youWin.position.set(360, 120);
        this._youWin.alpha = 0;
        this._container.addChild(this._youWin);

        this._played = new PIXI.Text(Translation.translation("Spins Played:"), new PIXI.TextStyle({
            fill: 0xffffff,
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 30,
            stroke: 0x000000,
            strokeThickness: 10,
            lineJoin: "round"
        }));
        this._played.anchor.set(0.5, 0.5);
        this._played.position.set(360, 490);
        this._played.alpha = 0;
        this._container.addChild(this._played);
    }

    private resetSpine(currSpine: PIXI.spine.Spine): void {
        currSpine.skeleton.setToSetupPose();
        currSpine.updateTransform();
        currSpine.visible = false;
    }

    private createFSOutroSpine(): void {
        this._fsOutroSpine = this.createSpine("FS_intro");
        this._container.addChild(this._fsOutroSpine);
    }

    private createSFSOutroSpine(): void {
        this._sfsOutroSpine = this.createSpine("SFS_intro");
        this._container.addChild(this._sfsOutroSpine);
    }

    private createSpine(name: string): PIXI.spine.Spine {
        const spineObj: PIXI.spine.Spine = new PIXI.spine.Spine(RockBottom.assetLoader.getSpineAsset(name));
        spineObj.position.set(360);
        spineObj.visible = false;
        spineObj.name = name;
        return spineObj;
    }

    private playSpineAnim(): void {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData(),
            currMode: RockBottomGameMode = parsedData.mode,
            isFS: boolean = currMode === RockBottomGameMode.FREESPIN,
            spineToPlay: PIXI.spine.Spine = isFS ? this._fsOutroSpine : this._sfsOutroSpine,
            tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this, {
            onStart: () => {
                this.resetSpine(spineToPlay);
                spineToPlay.visible = true;
                spineToPlay.alpha = 0;
                spineToPlay.state.setAnimation(0, "Outro", false);
                TweenLite.to([spineToPlay, this, this._overlay], {
                    alpha: 1,
                    duration: 0.3
                });
            }
        });
    }
}